<template>

    <section>
        <!-- ここから -->
            <div class="card_like-us">
                <swiper
                    :slides-per-view="1.5"
                    :space-between="30"
                    :grabCursor="true"
                    :speed="500"
                    :breakpoints='{
                        "520": {
                            "slidesPerView": 3.5,
                        },
                        "800": {
                            "slidesPerView": 6.1,
                        }
                    } '
                >
                    <swiper-slide v-for="brand in likeBrandsList">
                        <a :href="route('brand_detail', brand.id)" class=""><span>MORE</span></a>
                        <img v-bind:src="this.$store.state.const.AWS_S3_URL_HOST + brand.logo" alt="">
                        <div class="detail">
                            <h5>{{ brand.name }}</h5>
                        </div>
                    </swiper-slide>
                </swiper>
            </div>
        <!-- ここまで -->
    </section>

</template>



<script>
    //Swiper.js
    import { Swiper, SwiperSlide } from 'swiper/vue';
    import 'swiper/css';

    //Swiper.js - css
    import "swiper/css/pagination"
    import "swiper/css/navigation"

    //SwiperModules
    import SwiperCore, {
        Autoplay,
        Pagination,
        Navigation
    } from 'swiper';
    SwiperCore.use([
        Autoplay,
        Pagination,
        Navigation
    ]);

    export default {
        components: {
            //Swiper.js
            Swiper,
            SwiperSlide,
        },
        props: {
            likeBrands: Object,
        },
        computed: {
            likeBrandsList() {
                if(this.likeBrands) {
                    var list = [];
                    for (var i in this.likeBrands) {
                        if (this.likeBrands[i].brand[0].brand_images[0]) {
                            this.likeBrands.[i].brand[0].logo = this.likeBrands[i].brand[0].brand_images[0].path;
                        }
                        list.push(this.likeBrands[i].brand[0]);
                    }
                    return list;
                }
            },
        }
    }
</script>
